module.exports = __webpack_public_path__ + "media/images/pc/specials/common/event_detail_try_on-e358137d8901b27408616b46361bd846.jpg";